export const surveyIds = {
  allergy: 'f570cfc9-6e2d-4d11-8629-81dbab400bc6',
  oswestry: '75e365b6-ba74-4fe5-bc04-c83c7599e652',
  healthHistory: '2d1187fe-fe32-4aff-9fc8-695174e2f080',
  dash: '308ce8dc-3f20-467e-98b4-1e183d833b4d',
  surgicalHistory: 'f79a1436-b0e6-4b19-9774-f81de54373fb',
  medicationHistory: '15b532b9-ad5f-4b49-9e55-9b021e6b24dc',
  lefs: 'b54bb66e-506a-4191-ae8d-978251fcf154',
  backBournemouth: 'bda82ea2-a5b3-4145-817a-21ab464885ed',
  lifestyleHistory: '632c8555-023d-4d0e-a44b-32b096f0832a',
  familyHistory: '113cfd2a-7005-42de-bb58-b6a446cc3a63',
  ccs: '0a91c93a-c727-46d1-b997-7f21bc630f3c',
  reviewOfSystems: 'f3d2c6b0-c9a5-42ea-9a95-32c51131f001',
  neckBournemouth: 'c411eb11-d915-4e15-9a16-bdb933516257',
  ndi: 'b005e3d9-8ca4-4694-8525-7b63312b3c6c',
  reevaluation: '721e5ee1-4bc4-4754-92d9-c74576a015f5',
  interimVisitSurvey: '7d369d2a-8d0d-11ed-a1eb-0242ac120002',
  additionalComplaintSurvey: 'a91b9b3b-cde2-482e-8168-867b09ac16b4',
  headacheDisability: '72e4644e-f535-41a8-b6b9-c1479266a0be',
  abbreviatedCCS: '3a14995d-f06e-46f4-b8bb-5fbbe7a421e9',
  startBack: '86c92833-1a63-41a0-93a7-2947432029c2',
};

export const requestIds = {
  requestInfo: 'requestInfo',
  requestPhotoId: 'requestPhotoId',
  requestInsurance: 'requestInsurance',
  requestInsuranceCard: 'requestInsuranceCard',
};

export const surveyOrder = {
  oswestry: 0,
  dash: 1,
  lefs: 2,
  backBournemouth: 3,
  neckBournemouth: 4,
  ndi: 5,
  headacheDisability: 6,
  startBack: 7,
  reviewOfSystems: 8,
  healthHistory: 9,
  surgicalHistory: 10,
  medicationHistory: 11,
  allergy: 12,
  familyHistory: 13,
  lifestyleHistory: 14,
};

export const surveyIdsTypes = Object.entries(surveyIds).reduce(
  (
    obj: {
      [key: string]: keyof typeof surveyIds;
    },
    [name, id]
  ) => {
    const surveyName = name as keyof typeof surveyIds;
    obj[id] = surveyName;

    return obj;
  },
  {}
);

export type SurveyIds = keyof typeof surveyIds;

export const surveyIdsToNames: Record<string, string> = {
  [surveyIds.allergy]: 'Allergy',
  [surveyIds.oswestry]: 'Revised Oswestry Disability indexed',
  [surveyIds.healthHistory]: 'Health history',
  [surveyIds.dash]: 'Quick DASH',
  [surveyIds.surgicalHistory]: 'Surgical History',
  [surveyIds.medicationHistory]: 'Medication History',
  [surveyIds.lefs]: 'Lower Extremity Functional Scale (LEFS)',
  [surveyIds.backBournemouth]: 'Back Bournemouth Questionnaire',
  [surveyIds.lifestyleHistory]: 'Lifestyle History',
  [surveyIds.familyHistory]: 'Family History',
  [surveyIds.reviewOfSystems]: 'Review of Systems',
  [surveyIds.ccs]: 'Chief Complaint Survey',
  [surveyIds.neckBournemouth]: 'Neck Bournemouth Questionaire',
  [surveyIds.ndi]: 'Neck Disability Index (NDI)',
  [surveyIds.reevaluation]: 'Reevaluation',
  [surveyIds.interimVisitSurvey]: 'Interim Visit Survey',
  [surveyIds.additionalComplaintSurvey]: 'Additional Complaint Survey',
  [surveyIds.headacheDisability]: 'Headache Disability',
  [surveyIds.startBack]: 'Keele STarT Back Screening Tool',
  [surveyIds.abbreviatedCCS]: 'Abbreviated CCS',
  [requestIds.requestInfo]: 'Patient demographics',
  [requestIds.requestPhotoId]: 'Photo ID',
  [requestIds.requestInsuranceCard]: 'Insurance card',
  [requestIds.requestInsurance]: 'Insurance',
};
export const intakeSurveys = [
  {
    id: surveyIds.healthHistory,
    title: surveyIdsToNames[surveyIds.healthHistory],
  },
  {
    id: surveyIds.surgicalHistory,
    title: surveyIdsToNames[surveyIds.surgicalHistory],
  },
  {
    id: surveyIds.medicationHistory,
    title: surveyIdsToNames[surveyIds.medicationHistory],
  },
  {
    id: surveyIds.lifestyleHistory,
    title: surveyIdsToNames[surveyIds.lifestyleHistory],
  },
  {
    id: surveyIds.familyHistory,
    title: surveyIdsToNames[surveyIds.familyHistory],
  },
  {
    id: surveyIds.reviewOfSystems,
    title: surveyIdsToNames[surveyIds.reviewOfSystems],
  },
  { id: surveyIds.allergy, title: surveyIdsToNames[surveyIds.allergy] },
  { id: surveyIds.ccs, title: surveyIdsToNames[surveyIds.ccs] },
  {
    id: requestIds.requestPhotoId,
    title: surveyIdsToNames[requestIds.requestPhotoId],
  },
  {
    id: requestIds.requestInsurance,
    title: surveyIdsToNames[requestIds.requestInsurance],
  },
  {
    id: requestIds.requestInfo,
    title: surveyIdsToNames[requestIds.requestInfo],
  },
];

export const functionalDisabilitySurveys = [
  {
    id: surveyIds.backBournemouth,
    title: surveyIdsToNames[surveyIds.backBournemouth],
  },
  {
    id: surveyIds.neckBournemouth,
    title: surveyIdsToNames[surveyIds.neckBournemouth],
  },
  { id: surveyIds.lefs, title: surveyIdsToNames[surveyIds.lefs] },
  { id: surveyIds.ndi, title: surveyIdsToNames[surveyIds.ndi] },
  { id: surveyIds.dash, title: surveyIdsToNames[surveyIds.dash] },
  { id: surveyIds.oswestry, title: surveyIdsToNames[surveyIds.oswestry] },
  {
    id: surveyIds.startBack,
    title: surveyIdsToNames[surveyIds.startBack],
  },
];

const disabilitySurveyObj: { [key: string]: boolean } = {
  [surveyIds.oswestry]: true,
  [surveyIds.dash]: true,
  [surveyIds.ndi]: true,
  [surveyIds.lefs]: true,
  [surveyIds.backBournemouth]: true,
  [surveyIds.neckBournemouth]: true,
  [surveyIds.startBack]: true,
};

export const disabilitySurvey = Object.keys(disabilitySurveyObj);

/** Surveys excluded from the library entirely */
export const libraryExcludedSurveys = new Set([
  surveyIds.additionalComplaintSurvey,
  // Disability surveys — these are standardized instruments that shouldn't be customized.
  surveyIds.oswestry,
  surveyIds.dash,
  surveyIds.ndi,
  surveyIds.lefs,
  surveyIds.backBournemouth,
  surveyIds.neckBournemouth,
  surveyIds.startBack,
  surveyIds.headacheDisability,
]);

/** Surveys only visible in library for EHR clinics */
export const libraryEhrOnlySurveys = new Set([
  surveyIds.ccs,
  surveyIds.abbreviatedCCS,
  surveyIds.reevaluation,
  surveyIds.interimVisitSurvey,
]);

/**
 * Custom CCS IDs from clinic settings. Passed to helper functions
 * so they can recognize custom CCS surveys alongside built-in ones.
 */
export type CustomCCSIds = {
  customCCS?: string | null;
  customAbbreviatedCCS?: string | null;
  customReevaluation?: string | null;
  customInterim?: string | null;
};

export const isFullCCSSurveyId = (id: string | undefined | null, custom?: CustomCCSIds): boolean =>
  !!id && (id === surveyIds.ccs || (!!custom?.customCCS && id === custom.customCCS));

export const isAbbreviatedCCSSurveyId = (
  id: string | undefined | null,
  custom?: CustomCCSIds
): boolean =>
  !!id &&
  (id === surveyIds.abbreviatedCCS ||
    (!!custom?.customAbbreviatedCCS && id === custom.customAbbreviatedCCS));

export const isAnyCCSSurveyId = (id: string | undefined | null, custom?: CustomCCSIds): boolean =>
  isFullCCSSurveyId(id, custom) || isAbbreviatedCCSSurveyId(id, custom);

export const isAnyCCSOrAdditionalComplaint = (
  id: string | undefined | null,
  custom?: CustomCCSIds
): boolean => isAnyCCSSurveyId(id, custom) || id === surveyIds.additionalComplaintSurvey;

export const isReevaluationSurveyId = (
  id: string | undefined | null,
  custom?: CustomCCSIds
): boolean =>
  !!id &&
  (id === surveyIds.reevaluation ||
    (!!custom?.customReevaluation && id === custom.customReevaluation));

export const isInterimSurveyId = (id: string | undefined | null, custom?: CustomCCSIds): boolean =>
  !!id &&
  (id === surveyIds.interimVisitSurvey || (!!custom?.customInterim && id === custom.customInterim));

export const isReevalOrInterimSurveyId = (
  id: string | undefined | null,
  custom?: CustomCCSIds
): boolean => isReevaluationSurveyId(id, custom) || isInterimSurveyId(id, custom);

export const oldDashSpanishOptionsToNew = {
  '874634b5-6392-4bd8-abc7-e83c4d9f88b4': '3f29542b-253b-489d-9e3b-20e636574ed9',
  '86af7729-d606-4115-aadd-21acf2400d0f': '225bc5bd-08c9-4ff8-8083-b5b3adfb8f1d',
  '6c5ffdeb-b7bb-4fe6-8d9f-585f3f633b1e': '27378139-5a56-46b4-b96d-72882bff45ac',
  'bf2314a9-2392-4c7d-8fe9-e8745a3395ce': 'e9ef79d1-079d-45aa-b923-e11f996eb47e',
  '3b79363b-59c3-4df9-9797-bfa941a6650e': '128934f0-76b9-479c-a10c-705e57e9c255',
  '3213fe0b-d0de-4827-a0d0-eff6ea3c8b2f': '45046031-f70a-40cb-bc58-bc729442c94f',
  'c58f5ae1-784c-4c82-95d9-a6918999ebb3': '73536185-eeb2-4d62-ad39-de8ba906d0d6',
  '4427e745-9add-4035-90fc-bb9e1a19862c': 'e79e9f33-32bb-4eed-8e76-a1167a2ea9c5',
  'cff4cd7c-02c0-474b-aa37-f1bb02473aca': '78bfa045-f2ac-4d2e-9fb4-a850aed8a4df',
  '20554fd7-3204-4124-b777-0afa4aee0170': '74e6e2a5-b56e-487c-b0a6-0348d6fb2b0a',
  '1222311a-f16b-4066-939f-0432cf7a7bfb': 'ebf15b77-95f1-447b-bf68-5bb808ad1cda',
  '25125a20-a509-4899-9641-0e4334245c08': 'a159d2d2-15be-4874-a0aa-e6ff9d5dd3ad',
  '0c71016a-0a73-431d-86a4-085c5065a468': '80e7397f-6c85-4e7e-9523-618fc969a2ea',
  'ce614c03-c100-4e96-be3c-e51fe843db96': 'cf9fac56-7c80-4f12-b8dd-0c9f27466bbb',
  '69122b63-9123-46af-8307-214ac32b042d': '780fbc3d-55d0-4bc4-bc19-5891d221dd54',
  '6cb4ea2c-10a3-4c6f-b759-911f8d71c6b3': '72f46cbd-f416-4603-9b78-fd0feda219ef',
  '4942d1ae-1701-40f2-969c-834e534b1f33': '6d391d62-a6fd-49a3-8b2c-1ed2602e9273',
  'f336b93c-882b-431e-93c1-62459f798c97': 'e7cbc4eb-5ab5-4522-9000-f9d7509b770e',
  '107001cf-2449-4e34-98c1-030c00017a2c': '5fc3565e-e862-4089-b63a-0847a4cf5710',
  '4955eb00-0bf6-41ae-b15f-049e740ce0d4': 'e935f55f-3ff9-4982-8d18-7e0a300c16fe',
  '635cb3f0-0df1-47ca-afa8-99c625e7341d': 'f2e18f78-809e-475c-bfe6-0ddef8c9f105',
  'a2bee68d-07c1-478e-887f-49042ba4cd35': '83c9e911-7d17-4cbf-8985-07dc682aaca0',
  'bac7f87c-4067-47ad-bbac-3554487b6b1a': 'cd9db08b-f024-4a65-b3ec-f473304dfdf0',
  '6363fcd0-d8f3-4fcd-8651-4c0bb2d05b08': 'd0e2d218-4f90-41a2-a202-99094d232af6',
  'f0daf070-58f3-407f-bb49-47c6669d6495': '62497f13-dbfb-4b9b-ab60-f789aaf311ec',
  '3547128d-bcda-4a20-a6dc-c5ad9c90e75e': 'b263d624-d7a0-40c4-b728-ef79f22dd337',
  'cbd89ecd-4baa-4607-a3ec-d6ddd20db077': 'a5ca4c29-5e82-4845-8e12-492e295ee4bb',
  '7128adce-d961-41cf-996d-acd19dab0042': 'bccbef88-5b6f-4ace-a87d-651546569507',
  '2d731e09-4916-43ba-918f-4108cf8ec013': '51d5329a-72de-4106-be23-4d3d542d86fd',
  'd736ddba-4817-4972-a936-85e8158d0b5d': '8629218b-bbe5-4097-a555-b5ea53ce64ea',
  'bdc0c939-0666-4fb6-932b-2db0b059748f': '28e45460-c3be-486f-bb05-a17a42e09af7',
  'fcfbcdd6-4e76-47e8-96c4-27cb6770c3f1': '3efd8205-e185-41dd-98ae-e3e85d40a180',
  '3fcfd630-64ef-4043-a428-3151ba4d59e6': '7536a465-be34-4fe8-a15e-01694f93efa2',
  '4bf82155-8154-4c07-b211-3558f7d0d11b': 'bac2cba8-c272-44e9-af73-32cd74a3ab4c',
  '03ff493d-b16b-4b97-adac-553ac3376a7d': '30435439-9536-4220-8b55-68f4e95490f7',
  '8f2e3cdf-b2d7-45ee-a097-6c6c59fc891a': '123c55bc-b4bf-4c47-a72f-94dcf250d750',
  '3c2598e1-5e4a-401d-a70c-8127fe52bc21': 'c5bbb722-384e-4d35-8639-c426fad73e03',
  '01c00e0b-9ed1-401b-afdd-bcf9f49543f1': 'afd2c6ff-904c-45db-a47f-72c6ed33fa16',
  'c56849cf-df83-4bc4-8d3b-c12b26517459': 'b49d12ae-e6d4-47e9-bd9b-dca9f3c8af95',
  'ba4e089c-f324-468b-9c32-bc4452a4827b': 'f97e73c8-fa9a-4642-b054-4ec93b24f684',
  '9017e5da-1feb-47f0-991c-270a0e3097a5': '380d8ea1-5289-4c3f-9b83-f3d9d97f2d02',
  '54fe98cd-4dda-4658-92cb-146b34c1798e': 'bd5b0ecb-536c-4ec0-ab1a-2614a4dac1cb',
  '06f157bf-edb8-437b-b85a-78a8c1fb0f82': '94c9a942-4277-4c85-b2b3-d321980f486e',
  'ed2cd632-6fc5-43ce-b1ab-76371a9caa65': 'd6635458-69e8-4104-9c73-afcc7328c62a',
  '4471cd3f-b76c-4d7b-91bf-33d6faf6815e': 'cf4b91f3-cccb-4527-86ac-ccbe6d81703d',
  'b4c6008f-1ed7-4326-9e3a-6c2d5007c856': '8bba36ca-2ef9-4090-9edb-1fb14d3f051c',
  '8dfb6ad1-7638-4795-8b90-c8e096155d47': '607a7575-f4b8-47ad-9187-0795d502a900',
  '14b7d84b-a9a7-4412-a1b2-dca5d5095f0a': '1c2d09aa-1803-49e5-a0ff-107f72d49850',
  '67a4370f-bf51-4abc-9c4f-1b7565e5a58c': '730f1197-9631-429a-8726-d3bc604025fa',
  '75221958-ca8c-4069-81b7-b6ec0c113749': '8b4d79c8-5a6f-48c8-af8f-02701eaba241',
  '778d35d0-1ddd-492c-8683-3c404f15b578': '4fe22592-422f-4c7b-896a-c627f3fbf1ee',
  'cedb86c2-bbf9-4860-8be8-bf6cb83aa108': '7548a0ca-ee1f-48d2-8510-c96539ef8f18',
  'b83f4808-8351-4901-89b1-d526380b4cbc': 'd9daf25a-bf48-4d80-b938-452078756ec2',
  '607a3b51-8577-4ceb-9826-b9ca4b66cc9a': 'ec40b698-f9d5-4114-8693-879c4446c79d',
  '6a41bd78-0270-4470-bc45-63c983d92dd5': '369d8fa0-bf0b-445a-81a9-637a6d1e2560',
};
